import React, { useState } from "react";
import { backend_domain } from "../helpers";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";

const RelatedProductsCard = ({ related_item, cartUpdate, user }) => {
  const [currentQty, setCurrentQty] = useState(
    related_item?.sales_order_info?.exists
      ? related_item?.sales_order_info?.qty
      : 0
  );

  console.log(related_item);
  return (
    <div className="product-card bg-white px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
      <a
        href={`/singleProduct?id=${related_item?.item_code}`}
        className="product-card__thumb flex-center custom-product-card__thumb"
      >
        <img src={`${backend_domain}${related_item?.images[0]}`} alt="" />
      </a>
      <div className="custom-product-card__content ms-0 mt-12 product-card__content w-100">
        <h6 className="title text-lg fw-semibold mt-12 mb-8">
          <a
            href={`/singleProduct?id=${related_item?.item_code}`}
            className="link text-line-2"
          >
            {related_item?.item_name}
          </a>
        </h6>
        <p className="">
            <Link
              to={`/singleProduct?id=${related_item?.item_code}`}
              className="link text-line-1 text-gray-500 fw-normal"
              tabIndex={0}
            >
              {ReactHtmlParser(related_item?.description)}
            </Link>
          </p>

        <div className="flex-between gap-8 mt-24 flex-wrap">
          <div className="product-card__price">
            <span className="text-heading text-md fw-semibold ">
              {related_item?.prices[0]?.rate} KD
            </span>
          </div>
        </div>

        {user?.name == "guest" ? (
          <Link
            to={user?.name == "guest" ? "/login" : "/cart"}
            className="product-card__cart btn bg-main-50 justify-content-center mt-3 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8"
          >
            Add <i className="ph ph-shopping-cart" />
          </Link>
        ) : (
          <div className="mt-24">
            {currentQty > 0 ? (
              <div className="d-flex rounded-4 overflow-hidden">
                <button
                  type="button"
                  className="quantity__minus flex-shrink-0 h-48 w-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
                  onClick={() => {
                    setCurrentQty(currentQty - 1);

                    cartUpdate({
                      item_code: related_item?.item_code,
                      qty: currentQty - 1,
                      rate: related_item?.prices[0]?.rate,
                    });
                  }}
                >
                  <i className="ph ph-minus" />
                </button>
                <input
                  type="number"
                  className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center w-32 px-16"
                  id="stock"
                  readOnly
                  value={currentQty}
                />
                <button
                  type="button"
                  onClick={() => {
                    setCurrentQty(currentQty + 1);

                    cartUpdate({
                      item_code: related_item?.item_code,
                      qty: currentQty + 1,
                      rate: related_item?.prices[0]?.rate,
                    });
                  }}
                  className="quantity__plus flex-shrink-0 h-48 w-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
                >
                  <i className="ph ph-plus" />
                </button>
              </div>
            ) : (
              <button
                onClick={() => {
                  cartUpdate({
                    item_code: related_item?.item_code,
                    qty: 1.0,
                    rate: related_item?.prices[0]?.rate,
                  });
                  setCurrentQty(1);
                }}
                className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 w-100 justify-content-center"
              >
                Add <i className="ph ph-shopping-cart" />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RelatedProductsCard;
